import React from "react";

import {ThreeToggle} from "../helpers/ThreeToggle";

export class StudentModeForm extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state =
            {
                student_mode: window.app.logboek.getSessionField('student_mode'),


            }
        this.clicked = this.clicked.bind(this);

    }

    clicked(p_selected)
    {
        this.setState(
            {
                student_mode: p_selected,
            }
        )
        window.app.storeSessionFieldAndStoreLogboek("student_mode", p_selected);
    }



    render()
    {
        return (
            <>
                <ThreeToggle first_value='teacher' first_label='Leerkracht' second_value='both' second_label='Beide' third_value='student' third_label='Kind' selected={this.state.student_mode} callback={this.clicked}/>



            </>
        )
    }
}
